import { useEffect } from "react";

// A popover positioned with CSS anchor positioning can't stay glued to its
// trigger while the page scrolls underneath it, so while `active` we block
// wheel/touch scrolling everywhere except inside an open popover
// ([data-popover]). Ctrl/meta wheel (browser zoom) still passes through.
export function useScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const blockOutsideScroll = (e: Event) => {
      if (e instanceof WheelEvent && (e.ctrlKey || e.metaKey)) return;
      const target = e.target as Element | null;
      if (target?.closest?.("[data-popover]")) return;
      e.preventDefault();
    };
    const opts = { passive: false, capture: true } as const;
    window.addEventListener("wheel", blockOutsideScroll, opts);
    window.addEventListener("touchmove", blockOutsideScroll, opts);
    return () => {
      window.removeEventListener("wheel", blockOutsideScroll, {
        capture: true,
      });
      window.removeEventListener("touchmove", blockOutsideScroll, {
        capture: true,
      });
    };
  }, [active]);
}
